export enum SelectionSyncMessageType {
  SelectParts = 'physna:selection:select-parts',
  PartSelected = 'physna:selection:part-selected',
  ClearSelection = 'physna:selection:clear',
}

export type SelectionSyncSource = 'parent' | 'viewer';

export type SelectionSyncSide = 'asset1' | 'asset2';

export type SelectPartsMessage = {
  type: SelectionSyncMessageType.SelectParts;
  src: SelectionSyncSource;
  assetIds: string[];
  selectionPath?: string[];
  side?: SelectionSyncSide;
};

export type PartSelectedMessage = {
  type: SelectionSyncMessageType.PartSelected;
  src: SelectionSyncSource;
  assetIds: string[];
  selectionPath?: string[];
  side?: SelectionSyncSide;
};

export type ClearSelectionMessage = {
  type: SelectionSyncMessageType.ClearSelection;
  src: SelectionSyncSource;
  side?: SelectionSyncSide;
};

export const isMessageForSide = (message: { side?: SelectionSyncSide }, side?: SelectionSyncSide): boolean =>
  !message.side || !side || message.side === side;

export const isSelectPartsMessage = (value: unknown): value is SelectPartsMessage => {
  if (typeof value !== 'object' || value === null) return false;
  const message = value as { type?: unknown; assetIds?: unknown };
  return message.type === SelectionSyncMessageType.SelectParts && Array.isArray(message.assetIds);
};

export const isPartSelectedMessage = (value: unknown): value is PartSelectedMessage => {
  if (typeof value !== 'object' || value === null) return false;
  const message = value as { type?: unknown; assetIds?: unknown };
  return message.type === SelectionSyncMessageType.PartSelected && Array.isArray(message.assetIds);
};

export const isClearSelectionMessage = (value: unknown): value is ClearSelectionMessage => {
  if (typeof value !== 'object' || value === null) return false;
  const message = value as { type?: unknown };
  return message.type === SelectionSyncMessageType.ClearSelection;
};

export const extractAssetIdFromNodeName = (nodeName: string): string => nodeName.slice(0, nodeName.lastIndexOf('-'));

export const buildNodeNamePrefix = (assetId: string): string => `${assetId}-`;
